import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';
import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const TableHeader = styled.div`
  ${mixin.flex({ align: 'flex-end', justify: 'space-between' })}
  margin-bottom: 12px;
`;

export const TableTitle = styled.h3`
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('16')};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 18px;
  }
`;

export const TableSubtitle = styled.p`
  font-size: 13px;
  line-height: 130%;
  color: #777;

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('13')};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 14px;
  }
`;

export const Table = styled.table<{
  $bordered?: boolean;
}>`
  width: 100%;
  background-color: #fff;
  border-collapse: separate;
  ${({ $bordered }) =>
    $bordered && `border-top: 1px solid #000; border-bottom: 1px solid #000;`}
`;

export const THead = styled.thead``;

export const TH = styled.th<{
  $width?: string | number;
  $align?: 'left' | 'center' | 'right';
  $padding?: string;
}>`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-align: ${({ $align }) => $align || 'center'};
  white-space: nowrap;

  ${({ $width }) =>
    $width && `width: ${typeof $width === 'number' ? `${$width}px` : $width};`}

  padding: ${({ $padding }) => {
    if (!$padding) return '16px 12px';
    const withoutPx = $padding.replace(/px/g, '').trim();
    return withoutPx
      .split(/\s+/)
      .map(v => `${v}px`)
      .join(' ');
  }};

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('14')};
    padding: ${({ $padding }) => {
      if (!$padding) return mixin.pxToVw('16 12');
      const withoutPx = $padding.replace(/px/g, '').trim();
      return mixin.pxToVw(withoutPx);
    }};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 15px;
    padding: ${({ $padding }) => {
      if (!$padding) return '13px';
      const withoutPx = $padding.replace(/px/g, '').trim();
      return withoutPx
        .split(/\s+/)
        .map(v => `${v}px`)
        .join(' ');
    }};
  }
`;

export const TBody = styled.tbody``;

export const TR = styled.tr``;

export const TD = styled.td<{
  $align?: 'left' | 'center' | 'right';
  $padding?: string;
}>`
  font-size: 14px;
  line-height: 130%;
  color: #333;
  border-top: 1px solid #e5e5e5;
  text-align: ${({ $align }) => $align || 'center'};

  padding: ${({ $padding }) => {
    if (!$padding) return '8.5px 12px';
    const withoutPx = $padding.replace(/px/g, '').trim();
    return withoutPx
      .split(/\s+/)
      .map(v => `${v}px`)
      .join(' ');
  }};

  &.no-data {
    color: #777;
  }

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('14')};
    padding: ${({ $padding }) => {
      if (!$padding) return mixin.pxToVw('8.5 12');
      const withoutPx = $padding.replace(/px/g, '').trim();
      return mixin.pxToVw(withoutPx);
    }};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 16px;
    line-height: 135%;
    padding: ${({ $padding }) => {
      if (!$padding) return '9px 12px';
      const withoutPx = $padding.replace(/px/g, '').trim();
      return withoutPx
        .split(/\s+/)
        .map(v => `${v}px`)
        .join(' ');
    }};
  }
`;

export const TableFooter = styled.div`
  margin-top: 12px;
  font-size: 13px;
  line-height: 130%;
  color: #777;
  text-align: right;

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('12')};
    font-size: ${mixin.pxToVw('13')};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 14px;
  }
`;
